/**
 * Enum values for EditorManager
 */
/**
 * Specifies the position of the toolbar.
 */
export var ToolbarPosition;
(function (ToolbarPosition) {
    /**
     * Positions the toolbar at the top of the RichTextEditor.
     */
    ToolbarPosition["Top"] = "Top";
    /**
     * Positions the toolbar at the bottom of the RichTextEditor.
     */
    ToolbarPosition["Bottom"] = "Bottom";
})(ToolbarPosition || (ToolbarPosition = {}));
